import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 26px;
  text-align: center;
  min-height: 320px;

  @media (max-width: 767px) {
    padding: 38px 20px;
    min-height: 240px;
  }
`

export const IconWrapper = styled.div`
  margin-bottom: 26px;
  color: #cccccc;

  @media (max-width: 767px) {
    margin-bottom: 20px;
  }
`

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 12px 0;
  line-height: 1.3;

  @media (max-width: 767px) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`

export const Description = styled.p`
  font-size: 13px;
  color: #666666;
  margin: 0 0 26px 0;
  max-width: 320px;
  line-height: 1.5;

  @media (max-width: 767px) {
    font-size: 12px;
    margin-bottom: 20px;
    max-width: 240px;
  }
`
